import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
// import styles from "styles/component/Popper.module.scss";
// import styles from "styles/component/FcbPopOver.module.scss";
import styles from "styles/component/CustomCoursePopOver.module.scss";

// import asset from "json/assets";
import { fcbMarkerType } from "json/constants";
import { useCourseGPSNameList } from "hooks/CourseMapDetails";

export const HazardPopOverComponent = (props) => {
  const {
    markerType,
    handleChangeMarkerType,
    selectedMarkerMod2,
    // handelChangeMarkerColor,
    errorMsg,
    handleSave,
    errorComponent,
  } = props;
  const CourseGPSNameListResponse = useCourseGPSNameList();

  const convertData = (CourseGPSNameListResponse) => {
    let validNameList = CourseGPSNameListResponse?.filter(
      (item, index) => item?.name !== "None"
    );
    return validNameList;
  };

  const courseGPSNameList = useMemo(() => {
    return convertData(CourseGPSNameListResponse);
  }, [CourseGPSNameListResponse]);
  return (
    <Box className={styles.popover_body_new}>
      <FormControl>
        <FormLabel id="demo-radio-buttons-group-label">SELECT TYPE</FormLabel>
        <RadioGroup
          className={styles.marker_option}
          aria-labelledby="demo-radio-buttons-group-label"
          // defaultValue="FLAG"
          name="radio-buttons-group"
          value={markerType}
          onChange={handleChangeMarkerType}
        >
          {courseGPSNameList?.map((marker, index) => (
            <FormControlLabel
              value={marker.id}
              control={<Radio checked={marker.id === parseInt(markerType)} />}
              label={marker.name}
              key={index}
            />
          ))}
        </RadioGroup>
      </FormControl>
      {errorMsg && errorComponent()}
      <Box className={styles.popover_ftr}>
        <Button
          to={"#"}
          className={styles.blue_btn}
          onClick={() => handleSave()}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
};
